import { createRouter, createWebHistory } from 'vue-router'
import indexRouter from '@/router/router-item/home.js'
import jsyjhRouter from '@/router/router-item/jsyjh.js'
import liaisonStationRouter from '@/router/router-item/liaison.js' // 联络站
import liaisonStationRouterNew from '@/router/router-item/liaisonNew.js' // 联络站（新）
const routes = [
  {
    path: '/',
    redirect: '/homePage'
  },
  // 首页
  {
    path: '/index',
    name: '首页',
    component: () => import('@/views/index/index.vue'),
    children: indexRouter.routerList
  },
  // 建设研究会
  {
    path: '/jsyjh',
    name: 'jsyjh',
    component: () => import('@/views/jsyjh/index.vue'),
    children: jsyjhRouter.routerList
  },
  // 联络站
  {
    path: '/liaisonStation',
    name: 'liaisonStation',
    component: () => import('@/views/liaisonStation/index.vue'),
    children: liaisonStationRouter.routerList
  },
  // 联络站
  {
    path: '/liaisonStationNew',
    name: 'liaisonStationNew',
    component: () => import('@/views/liaisonStationNew/index.vue'),
    children: liaisonStationRouterNew.routerList
  },
  // 预览
  {
    path: '/previewImage',
    component: () => import('@/views/previewImage.vue'),
    name: '预览',
    children: []
  },
  // 页面不存在
  {
    path: '/:catchAll(.*)',
    name: 'notFound',
    component: () => import('@/views/notFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
